import React from "react";
import { RIGHT_DARK } from "@etiquette-ui/colors";
import { CardTitleComponent } from "../../Group/styles";
import CustomMetricData from "./CustomMetricData";
import { CustomCardTemplate, CustomRow } from "../styles";

const ClosedSalesCash: React.FC<{ totalSales: string, salesPerGuest: string, closedSales: string, cashPercentage: string }> = ({ totalSales, salesPerGuest, closedSales, cashPercentage }) => {
  return (
    <CustomCardTemplate
      background={"white"}
      noPadding={false}
      header={
        <CustomRow>
          <CardTitleComponent title={"Total"} />
          <CardTitleComponent title={"Guest"} />
          <CardTitleComponent title={"Closed"} />
          <CardTitleComponent title={"Cash %"} />
        </CustomRow>
      }
      body={
        <CustomRow>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {totalSales}
            </CustomMetricData>
          </div>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {salesPerGuest}
            </CustomMetricData>
          </div>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {closedSales}
            </CustomMetricData>
          </div>
          <div className="column">
            <CustomMetricData size={"big"} weight={"bold"} color={RIGHT_DARK}>
              {cashPercentage}
            </CustomMetricData>
          </div>
        </CustomRow>
      }
    />
  );
};

export default ClosedSalesCash;
